import { render, staticRenderFns } from "./FieldListAsList.vue?vue&type=template&id=3a9938ba&scoped=true"
import script from "./FieldListAsList.vue?vue&type=script&lang=js"
export * from "./FieldListAsList.vue?vue&type=script&lang=js"
import style0 from "./FieldListAsList.vue?vue&type=style&index=0&id=3a9938ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9938ba",
  null
  
)

export default component.exports